export default __webpack_public_path__ + "static/globe_rating-8f22f09c303d4d33bf18a029e689c89f.png";